import clsx from "clsx";
import { ChatIcon } from "@/shared/icons";

type Props = {
  onClick: () => void;
  hasIndicator?: boolean;
};

export default function ChatOpenToggle({ onClick, hasIndicator }: Props) {
  return (
    <button
      type="button"
      className={clsx(
        "relative flex items-center justify-center w-[2.625rem] aspect-square p-0 rounded-[0.5rem] overflow-hidden",
        "bg-gradient-to-r from-dark-900/80 to-dark-900/80",
      )}
      onClick={onClick}
    >
      <ChatIcon size={20} className="text-white z-1" />
      {hasIndicator && (
        <>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_120%_-20%,_#2EEE4BBB_0%,_transparent_60%)]" />
          <div className="absolute w-1.5 aspect-square rounded-full bg-[#2EEE4B] top-1.5 right-1.5" />
        </>
      )}
    </button>
  );
}
